var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.ORDER_ABNORMAL_FIVE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          radio: _vm.radio,
          "before-reset-search": _vm.beforeResetSearch,
          "tooltip-config": { showAll: false, enterable: false },
          selection: _vm.selection,
          "default-sort": _vm.defaultSort,
          "row-style": _vm.rowStyleFun,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "sort-change": _vm.sortChange,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-props": ["channel", "storeIdList"],
                    multiple: "",
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.No"),
                          prop: "orderNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("InternalOrder.No") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderNo", $$v)
                            },
                            expression: "queryParams.orderNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.SKU"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("InternalOrder.SKU") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("orderNewPatch.Status"),
                          prop: "totalOrderStatus",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("orderNewPatch.Status"),
                            multiple: "",
                            "option-list": _vm.ORDER_INTERNAL_NO_STATUS_LIST,
                          },
                          model: {
                            value: _vm.statusList,
                            callback: function ($$v) {
                              _vm.statusList = $$v
                            },
                            expression: "statusList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseOrder2.means"),
                          prop: "shippingMethod",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("BusinessPurchaseOrder2.means"),
                            "option-list": _vm.CSG_ORDER_SHIPPING_METHODS_LIST,
                          },
                          model: {
                            value: _vm.queryParams.shippingMethod,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "shippingMethod", $$v)
                            },
                            expression: "queryParams.shippingMethod",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "cusId",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("PreoccupationManagement.Three"),
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "PreoccupationManagement.Three"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime_order,
                            callback: function ($$v) {
                              _vm.queryParamsTime_order = $$v
                            },
                            expression: "queryParamsTime_order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.JobID"),
                          prop: "logisticsNo",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: { placeholder: _vm.$t("InternalOrder.JobID") },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.logisticsNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsNo", $$v)
                            },
                            expression: "queryParams.logisticsNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("InternalOrder.CourierName"),
                          prop: "logisticsCompany",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            multiple: "",
                            placeholder: _vm.$t("InternalOrder.CourierName"),
                            "option-list": _vm.CourierNameList,
                          },
                          model: {
                            value: _vm.queryParams.logisticsCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "logisticsCompany", $$v)
                            },
                            expression: "queryParams.logisticsCompany",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _vm.$store.getters.cusId
                      ? _c(
                          "el-button",
                          {
                            staticClass: "delete-btn",
                            attrs: { type: "danger" },
                            on: { click: _vm.onCreate },
                          },
                          [_vm._v(_vm._s(_vm.$t("addText")))]
                        )
                      : _vm._e(),
                    _vm.$store.getters.cusId
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onImport },
                          },
                          [_vm._v(_vm._s(_vm.$t("orderNewPatch.Import")))]
                        )
                      : _vm._e(),
                    _c("BjFrontendExport", {
                      staticClass: "main-btn",
                      attrs: {
                        type: "primary",
                        "label-list": _vm.labelList,
                        rows: _vm.selectedRows,
                        "file-name": "Sales Order.csv",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop === "orderTime"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "orderTime",
                            title: _vm.$t("orderNewPatch.orderDate"),
                            width: "165px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop]
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "creationDate"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "creationDate",
                            title: _vm.$t("orderNewPatch.creationDate"),
                            width: "165px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop],
                                            {
                                              isSession: true,
                                              dateFormat: "DD/MM/YYYY HH:mm",
                                            }
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "sapPushTime"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "sapPushTime",
                            title: _vm.$t("orderNewPatch.sapPushTime"),
                            width: "165px",
                            sortable: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("timeFilters")(
                                            scope.row[col.prop]
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                            "show-overflow-tooltip":
                              col.prop !== "bjTableAction",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop == "cusId"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerList.bjGet(
                                                scope.row.cusId
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "outerOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.webReference)
                                            ),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row.webReference,
                                            },
                                          }),
                                        ]
                                      : col.prop === "sapOrderNo"
                                      ? [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row[col.prop])),
                                          ]),
                                          _c("BjCopyIcon", {
                                            attrs: {
                                              copy: scope.row[col.prop],
                                            },
                                          }),
                                        ]
                                      : col.prop === "logisticsNo"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openTrackingDetails(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(scope.row[col.prop])
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "totalOrderStatus"
                                      ? [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  scope.row[col.prop] === 1
                                                    ? "success"
                                                    : "info",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.ORDER_INTERNAL_NO_STATUS_LIST.bjGet(
                                                      scope.row[col.prop]
                                                    )
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      : col.prop === "orderHandleStatus"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.totalOrderStatus ==
                                                  1 &&
                                                  scope.row.orderHandleStatus ==
                                                    -1
                                                  ? _vm.$t(
                                                      "ThreePartySalesOrder.OnHold"
                                                    )
                                                  : _vm.$t(
                                                      _vm.ORDER_WMS_STATUS_LIST.bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "shippingMethod"
                                      ? [
                                          _c("el-tag", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.CSG_ORDER_SHIPPING_METHODS_LIST.bjGet(
                                                    scope.row[col.prop]
                                                  )
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "isNeedQuota"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod
                                                  .toLowerCase()
                                                  .includes("csg manual")
                                                  ? scope.row.isNeedQuota
                                                    ? "Yes"
                                                    : " "
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "shippingWarehouse"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.circulationStatus ==
                                                  "1"
                                                  ? scope.row[col.prop]
                                                  : null
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : col.prop === "quotedAmount"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod
                                                  .toLowerCase()
                                                  .includes("csg manual")
                                                  ? scope.row.quotedAmount
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "quotaOrNot"
                                      ? [
                                          scope.row.shippingMethod
                                            .toLowerCase()
                                            .includes("csg manual")
                                            ? _c("el-tag", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      _vm.ORDER_QUOTE_TYPES_STATUS.bjGet(
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  )
                                                ),
                                              ])
                                            : _c("span", [_vm._v(_vm._s(" "))]),
                                        ]
                                      : col.prop === "isProvideSize"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod
                                                  .toLowerCase()
                                                  .includes("customer manual")
                                                  ? scope.row.isProvideSize
                                                    ? "Yes"
                                                    : " "
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "isSizeWrite"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.shippingMethod
                                                  .toLowerCase()
                                                  .includes("customer manual")
                                                  ? scope.row.repLength
                                                    ? "Yes"
                                                    : " "
                                                  : " "
                                              )
                                            ),
                                          ]),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("operationText")) +
                                        " "
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("InternalOrder.ps1")
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("i", {
                                          staticClass: "el-icon-question",
                                          staticStyle: { color: "#082dc3" },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(props.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    props.row.totalOrderStatus != 7
                                      ? _c(
                                          "el-dropdown",
                                          {
                                            directives: [
                                              {
                                                name: "hasDropdownChildren",
                                                rawName:
                                                  "v-hasDropdownChildren",
                                              },
                                            ],
                                            attrs: {
                                              disabled:
                                                props.row.totalOrderStatus ==
                                                  3 &&
                                                ([0, 2, 3, 5].includes(
                                                  props.row.orderHandleStatus
                                                ) ||
                                                  !props.row.innerOrderNo),
                                            },
                                            on: {
                                              command: function ($event) {
                                                return _vm.command(
                                                  $event,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "el-dropdown-link",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "AccountManagement.common.operate"
                                                    )
                                                  )
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-arrow-down el-icon--right",
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "el-dropdown-menu",
                                              {
                                                attrs: { slot: "dropdown" },
                                                slot: "dropdown",
                                              },
                                              [
                                                ![7, 8].includes(
                                                  props.row.totalOrderStatus
                                                ) &&
                                                ![0, 3, 6].includes(
                                                  props.row.orderHandleStatus
                                                )
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: "edit",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("editText")
                                                          ) + " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.totalOrderStatus == 1
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: "push",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ThreePartySalesOrder.push"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.totalOrderStatus == 2
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command:
                                                            "handleNormal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ThreePartySalesOrder.confirmation"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                [1, 3].includes(
                                                  props.row.totalOrderStatus
                                                )
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: "urgent",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "urgentText"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                !_vm.$store.getters.cusId &&
                                                [3].includes(
                                                  props.row.totalOrderStatus
                                                ) &&
                                                props.row.sapOrderNo
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: "package",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "goodsPage.package.edit"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.totalOrderStatus ==
                                                  1 &&
                                                props.row.orderHandleStatus ==
                                                  -1
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "permission",
                                                            rawName:
                                                              "v-permission:BusinessAbnormalOrder_openOrClose",
                                                            arg: "BusinessAbnormalOrder_openOrClose",
                                                          },
                                                        ],
                                                        attrs: {
                                                          command: "Release",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ThreePartySalesOrder.ReleaseHold"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.totalOrderStatus ==
                                                  1 &&
                                                props.row.orderHandleStatus !=
                                                  -1
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "permission",
                                                            rawName:
                                                              "v-permission:BusinessAbnormalOrder_openOrClose",
                                                            arg: "BusinessAbnormalOrder_openOrClose",
                                                          },
                                                        ],
                                                        attrs: {
                                                          command: "Hold",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "ThreePartySalesOrder.HoldOrder"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.shippingMethod &&
                                                props.row.shippingMethod
                                                  .toLowerCase()
                                                  .includes("csg manual") &&
                                                props.row.totalOrderStatus ==
                                                  8 &&
                                                !_vm.$store.getters.cusId
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            props.row
                                                              .isNeedQuota &&
                                                            props.row
                                                              .quotaOrNot != 2,
                                                          command:
                                                            "fillInLabel",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "WarehouseManagement.form.Label"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.shippingMethod &&
                                                props.row.shippingMethod
                                                  .toLowerCase()
                                                  .includes("csg manual") &&
                                                props.row.totalOrderStatus ==
                                                  8 &&
                                                !_vm.$store.getters.cusId
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            !props.row
                                                              .isNeedQuota ||
                                                            props.row
                                                              .quotaOrNot == 2,
                                                          command:
                                                            "fillInPrice",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "WarehouseManagement.form.Quote"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.shippingMethod &&
                                                props.row.shippingMethod
                                                  .toLowerCase()
                                                  .includes("csg manual") &&
                                                props.row.totalOrderStatus ==
                                                  8 &&
                                                _vm.$store.getters.cusId
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            !props.row
                                                              .isNeedQuota ||
                                                            props.row
                                                              .quotaOrNot != 1,
                                                          command:
                                                            "ConfirmPrice",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "WarehouseManagement.form.isQuotation"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.shippingMethod ==
                                                  "CUSTOMER MANUAL" &&
                                                props.row.totalOrderStatus == 8
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            props.row
                                                              .isProvideSize &&
                                                            ![
                                                              props.row
                                                                .repLength,
                                                              props.row
                                                                .repWidth,
                                                              props.row
                                                                .repHeight,
                                                              props.row
                                                                .repWeight,
                                                            ].every(function (
                                                              e
                                                            ) {
                                                              return e > 0
                                                            }),
                                                          command:
                                                            "fillInLabel",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "WarehouseManagement.form.Label"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.shippingMethod ==
                                                  "CUSTOMER MANUAL" &&
                                                props.row.totalOrderStatus ==
                                                  8 &&
                                                !_vm.$store.getters.cusId
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          disabled:
                                                            !props.row
                                                              .isProvideSize ||
                                                            ![
                                                              props.row
                                                                .repLength,
                                                              props.row
                                                                .repWidth,
                                                              props.row
                                                                .repHeight,
                                                              props.row
                                                                .repWeight,
                                                            ].every(function (
                                                              e
                                                            ) {
                                                              return e == null
                                                            }),
                                                          command: "fillInSize",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "WarehouseManagement.form.Dimension"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                props.row.totalOrderStatus == 8
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command:
                                                            "ModifyTrans",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "WarehouseManagement.form.Shipping"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                ![0, 3, 6].includes(
                                                  props.row.orderHandleStatus
                                                )
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: "cancel",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "cancelText"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.showFeeButton
                                                  ? _c(
                                                      "el-dropdown-item",
                                                      {
                                                        attrs: {
                                                          command: "feeTab",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "feeTab.fee"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.$store.getters.cusId &&
                                    props.row.totalOrderStatus == 7
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.customerDelivery(
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "InternalSalesOrderDetails.customerDelivery"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    props.row.totalOrderStatus == 7 &&
                                    props.row.shippingMethod == "PICKUP" &&
                                    ![0, 3, 6].includes(
                                      props.row.orderHandleStatus
                                    )
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onDelete(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("cancelText")))]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ExcelImportDialog", {
        ref: "ExcelImport",
        on: { submit: _vm.handleQuery },
      }),
      _c("delveryDialog", {
        ref: "delveryDialogRef",
        on: { reFresh: _vm.reFresh },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "" +
              _vm.$t("editText") +
              _vm.$t("goodsSku.detail.Price") +
              " (AUD)",
            visible: _vm.dialogFormVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "quotedAmount",
                    label: _vm.$t("goodsSku.detail.Price") + ":",
                  },
                },
                [
                  _c("BjInputMoney", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      disabled: _vm.form.isDisabled,
                      placeholder: "AUD",
                    },
                    model: {
                      value: _vm.form.quotedAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "quotedAmount", $$v)
                      },
                      expression: "form.quotedAmount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              !_vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogFormVisible = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("cancelText")))]
                  )
                : _vm._e(),
              !_vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.saveAmount()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("saveText")))]
                  )
                : _vm._e(),
              _vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelAmount()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("WarehouseManagement.form.refuse")))]
                  )
                : _vm._e(),
              _vm.form.isDisabled
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doneAmount()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("WarehouseManagement.form.agree")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("WarehouseManagement.form.Shipping"),
            visible: _vm.dialogShippingVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShippingVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "Shippingform",
              attrs: { model: _vm.Shippingform, rules: _vm.ShippingformRules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "shippingMethod",
                    label: _vm.$t("orderNewPatch.Shipping") + ":",
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: { "option-list": _vm.ShippingList },
                    model: {
                      value: _vm.Shippingform.shippingMethod,
                      callback: function ($$v) {
                        _vm.$set(_vm.Shippingform, "shippingMethod", $$v)
                      },
                      expression: "Shippingform.shippingMethod",
                    },
                  }),
                ],
                1
              ),
              _vm.Shippingform.shippingMethod == "CSG MANUAL"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "isNeedQuota",
                        label:
                          _vm.$t("WarehouseManagement.form.Quotation") + ":",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.STATUS_YES_TRUE },
                        model: {
                          value: _vm.Shippingform.isNeedQuota,
                          callback: function ($$v) {
                            _vm.$set(_vm.Shippingform, "isNeedQuota", $$v)
                          },
                          expression: "Shippingform.isNeedQuota",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.Shippingform.shippingMethod == "CUSTOMER MANUAL"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "isProvideSize",
                        label: _vm.$t("WarehouseManagement.form.check") + ":",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.STATUS_YES_TRUE },
                        model: {
                          value: _vm.Shippingform.isProvideSize,
                          callback: function ($$v) {
                            _vm.$set(_vm.Shippingform, "isProvideSize", $$v)
                          },
                          expression: "Shippingform.isProvideSize",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogShippingVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateShapping()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("WarehouseManagement.form.Dimension"),
            visible: _vm.dialogSizeVisible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSizeVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "SizeForm",
              attrs: { model: _vm.SizeForm, rules: _vm.SizeFormRules },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Length"),
                    prop: "repLength",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repLength,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repLength", $$v)
                        },
                        expression: "SizeForm.repLength",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("cm")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Width"),
                    prop: "repWidth",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repWidth,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repWidth", $$v)
                        },
                        expression: "SizeForm.repWidth",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("cm")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Height"),
                    prop: "repHeight",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repHeight,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repHeight", $$v)
                        },
                        expression: "SizeForm.repHeight",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("cm")])],
                    2
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("WarehouseManagement.form.Weight"),
                    prop: "repWeight",
                  },
                },
                [
                  _c(
                    "BjInputMoney",
                    {
                      model: {
                        value: _vm.SizeForm.repWeight,
                        callback: function ($$v) {
                          _vm.$set(_vm.SizeForm, "repWeight", $$v)
                        },
                        expression: "SizeForm.repWeight",
                      },
                    },
                    [_c("template", { slot: "append" }, [_vm._v("kg")])],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSizeVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updateSize()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("DataForm", {
        ref: "DataForm",
        on: { reFresh: _vm.reFresh, batchDeleteApi: _vm.batchDeleteApi },
      }),
      _c("DeliverDialog", { ref: "DeliverDialogRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }